import { useTableProfile as useSharedTableProfile } from '@shared/UI/DataTable/useTableProfile';

export function useTableProfile(pageKey) {
  return useSharedTableProfile('GenCRM', pageKey);
}

export default useTableProfile;
